<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="渠道统计" :header-visible="true" :back-visible="true" :user-list-lock.sync="userListLock" controller="h5" action="channel" :title-type-lock="false"/><!--参数都可以不传-->
    <scroll-refresh>
      <div class="tools-wrap wap-channel-wrap">
        <div :class="chartSlideLock ? 'rows-div active' : 'rows-div'">
          <div class="top-info-area">
            <span class="s_title">渠道统计</span>
            <span class="s_right">
              <font v-if="chartsSort.options.length">排序</font>
              <el-select
                v-model="chartsSort.value"
                placeholder="请选择排序方式"
                size="mini"
                v-if="chartsSort.options.length"
                @change="setChartsSort">
                <el-option
                  v-for="item in chartsSort.options"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select>
              <el-button :class="screenBtnStyle ? 'active' : ''" type="primary" @click="showFilter">筛选</el-button>
            </span>
          </div>
          <div class="chart-div">
            <bi-bar-line
              :data="chartsData.data"
              :data1="chartsData.data1"
              :options="chartsData.options"
              :refresh="chartsData.refresh"
              @reload="initCharts"/>
          </div>
        </div>
        <div class="channel-list-wrap">
          <el-row class="list-title">
            <div>渠道名</div>
            <div>资源数</div>
            <div>实际签约数</div>
            <div>实际转化率</div>
          </el-row>
          <data-list :url="url"
                     @tapEvent="showChannelInfo"
                     :search-data="searchData"
                     :refresh.sync="refresh"
                     :refresh-lock="true">
            <template slot-scope="{ item, index, header, refresh }">
              <el-row class="channel-list-level channel-list-level1">
                <div><span>{{ item.channel_name }}<i :class="item.show ? 'active' : ''" v-if="item.list"></i></span></div>
                <div>{{ item.count_all }}</div>
                <div>{{ item.sign_month_real }}</div>
                <div>{{ item.sign_p }}</div>
              </el-row>
              <div v-show="item.show" v-if="item.list">
                <el-row class="channel-list-level channel-list-level2" v-for="ii in item.list" :key="ii.custom_from_sub">
                  <div>{{ ii.channel_name_str !== '' ? ii.channel_name_str : ii.custom_from_sub }}</div>
                  <div>{{ ii.count_all }}</div>
                  <div>{{ ii.sign_month_real }}</div>
                  <div>{{ ii.sign_p }}</div>
                </el-row>
              </div>
            </template>
          </data-list>
        </div>
      </div>
    </scroll-refresh>
    <popup-filter :show-lock.sync="showFilterLock" :search-data.sync="searchData" :search-ds="searchDsUrl">
      <el-button slot="close-button" @click="closePopupFilter" class="btn-close-popup-fullpage"><font>×</font></el-button>
    </popup-filter>
    <el-button :class="chartSlideLock ? 'btn-chart-slide active' : 'btn-chart-slide'" @click="chartareaSlide"></el-button>
  </div>
</template>
<script>
import header from '@/pages/h5/compoments/header';
import scrollRefresh from '@/pages/h5/compoments/scrollRefresh';
import BiBarLine from '@/components/charts/biBarLine';
import popupFilter from './compoments/popupFilter';
import common from '@/pages/bi/common';
import dataList from '@/pages/h5/compoments/dataList';

let constDict = {
};

export default {
  data() {
    return {
      chartSlideLock: false,
      userListLock: true,
      constDict,
      chartsData: {
        refresh: 1
      },
      chartsSort: {
        options: [],
        value: '资源数'
      },
      refresh: false,
      showFilterLock: false,
      searchData: {
        gid: '',
        teacher_id: [],
        timeline: [],
        roleid: ''
      },
      url: '/index/b_i_channel/getChannelPage',
      searchDsUrl: '/index/b_i_channel/index',
      screenBtnStyle: false,
    };
  },
  components: {
    'wap-header': header,
    scrollRefresh,
    BiBarLine,
    popupFilter,
    dataList
  },
  mixins: [common],
  methods: {
    init() {
      this.refresh = true;
      this.initCharts();
    },
    initCharts() {
      this.fetchData({
        url: '/index/b_i_channel/getChannelChart',
        field: 'chartsData',
        param: this.searchData,
        option: {
          margin: {
            top: 50, right: 30, bottom: 20, left: 0
          },
          colors: ['#4F5DE0', '#67DCFF', '#FF9C06'],
          barWidth: 40,
          defaultBarWidth: 60,
          labelWidthPercent: 100 / 3.5,
          domainType: 'string',
          groupType: true,
          exY1: '%',
          helpLine: true,
          fontSize: '3vw',
        },
        sort: 'chartsSort'
      });
    },
    setChartsSort() {
      this.chartsData = this.sortData(this.chartsData, this.chartsSort.value);
    },
    closePopupFilter() {
      this.showFilterLock = false;
    },
    showFilter() {
      this.showFilterLock = true;
    },
    showChannelInfo(item) {
      item.show = !item.show;
    },
    chartareaSlide() {
      this.chartSlideLock = !this.chartSlideLock;
    }
  },
  watch: {
    showFilterLock(v) {
      if (!v) {
        this.$nextTick(this.init);
        this.refresh = true;
      }
      if (this.searchData.teacher_id.length > 0
          || this.searchData.timeline.length > 0) {
        this.screenBtnStyle = true;
      } else {
        this.screenBtnStyle = false;
      }
    }
  },
  mounted() {
    this.$http
      ._get({
        url: this.searchDsUrl
      })
      .then(({ data }) => {
        this.searchData.roleid = typeof data.roleids === 'object' ? data.roleids[0].roleid : data.roleids;
        this.init();
      });
  }
};
</script>
